import { STATUS } from 'services/types';

import i18n from 'i18next';
import { registerQueryFilterLabels } from 'components/organisms/filters/query-form/labels/QueryFilterLabels';
import { DIGITAL_PRODUCT_TYPE } from 'services/music-product-digital/types/enums';
import { IMusicProductDigitalSearch } from 'services/music-product-digital/types/query';
import { booleanLabel } from 'utils/components/inputs/booleanLabel';

registerQueryFilterLabels<IMusicProductDigitalSearch>('musicProductsDigital', {
  status: ({ value }) =>
    value !== undefined ? i18n.t(`enum.STATUS.${STATUS[value as STATUS]}`) : null,

  productType: ({ value }) =>
    value !== undefined
      ? i18n.t(`enum.DIGITAL_PRODUCT_TYPE.${DIGITAL_PRODUCT_TYPE[value as DIGITAL_PRODUCT_TYPE]}`)
      : null,

  deliveryDiscrepancy: booleanLabel('input.label.deliveryDiscrepancy'),
  hasDeliveryToAccept: booleanLabel('input.label.hasDeliveryToAccept'),
  hasDuplicatedArtist: booleanLabel('input.label.hasDuplicatedArtist'),
  hasContracts: booleanLabel('input.label.hasContracts'),
});
